.show {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.edit {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}

.input {
  min-inline-size: 10rem;
  block-size: 28px;
  padding: 0 0.5rem;
  border: 1px solid var(--border);
  border-radius: 0.375rem;
  background: var(--surface-raised);
  color: var(--text);
  font: inherit;
}

.refusal {
  margin: 0;
  font-weight: 600;
  color: var(--danger-text);
}
